import { useCssVars } from "../lib/use-css-vars";

interface UsageBarProps {
  label: string;
  current: number;
  limit: number;
  showThresholds?: boolean;
}

export function UsageBar({ label, current, limit, showThresholds = true }: UsageBarProps) {
  const pct = limit > 0 ? Math.min(100, Math.round((current / limit) * 100)) : 0;
  const color = showThresholds
    ? pct > 90 ? "bg-red-500" : pct > 70 ? "bg-yellow-500" : "bg-riot-gold-500"
    : "bg-riot-gold-500";

  // Width is a runtime percentage, so it can't be a Tailwind class.
  // Setting it via a CSS variable + ref keeps the rendered HTML free
  // of inline `style="..."` attributes (CSP `style-src 'self'`).
  const fillRef = useCssVars<HTMLDivElement>({ "--w": `${pct}%` });

  return (
    <div>
      <div className="mb-1 flex justify-between text-xs text-gray-500 dark:text-riot-navy-300">
        <span>{label}</span>
        <span>{current} / {limit === -1 ? "Unlimited" : limit}</span>
      </div>
      <div className="h-2 rounded-full bg-gray-200">
        <div ref={fillRef} className={`h-2 rounded-full [width:var(--w)] ${color}`} />
      </div>
    </div>
  );
}
